import React from 'react'

const Footer = () => {
  return (
   <div className="footer-wrapper col  text-center  d-flex align-items-center justify-content-center">
          <p>&copy; <a href="https://www.linkedin.com/in/nurullah-arslan-889661237/"> Nurullah</a></p> 
   </div>
  )
}

export default Footer